// F46 — hàm thuần, dùng chung cho chặng ④ và phần tóm tắt tập chưa viết ở ⑤.
// Không gọi API localize riêng: `outline` đã mang cặp tên do chặng ③ ghi.
export interface LocalizedNamePairSource { name?: string | null; localizedName?: string | null; tier?: string | null }

const clean = (v: string | null | undefined): string => String(v ?? '').trim();

/** Tối đa ba nhân vật chính đã thực sự đổi tên, theo thứ tự khung xương. */
export const localizedNamePairs = (characters: ReadonlyArray<LocalizedNamePairSource> | null | undefined): Array<{ original: string; localized: string }> =>
  (characters ?? [])
    .filter((c) => c.tier === 'lead')
    .map((c) => ({ original: clean(c.name), localized: clean(c.localizedName) }))
    .filter((p) => !!p.original && !!p.localized && p.original !== p.localized)
    .slice(0, 3);

export const originalNameSummaryNotice = (characters: ReadonlyArray<LocalizedNamePairSource> | null | undefined): string | null => {
  const pairs = localizedNamePairs(characters);
  if (!pairs.length) return null;
  return `Tóm tắt ở đây dùng tên gốc — kịch bản ⑤ sẽ viết bằng tên mới (ví dụ ${pairs.map((p) => `${p.original} → ${p.localized}`).join(', ')}).`;
};
